module.exports = "<div class=\"n7-layout-page-404\">\n  <h1>{{ 'i18n.layouts.page_404' | translate }}</h1>\n</div>"